module.exports = __webpack_public_path__ + "img/startMarker.50eab3b1.png";